const LayerStyleHelper = (layerName) => {
  const names = layerName.split(':');
  const sldName = names[1] + '_std';
  if (names[0] === 'rrk') {
    if (names[1] == 'potclimaterefugiacombined_2016_202401_t3_v5') {
      return 'potclimaterefugiacombined_2016_202401_t3_v5_expscore4';
    } else if (names[1] == 'goldspottedoakborer_20102021_202312_t2_v5') {
      return 'goldspottedoakborer_20102021_202312_T2_v5_mort_tpa';
    } else {
      return sldName;
    }
  } else {
    return null;
  }
};
export { LayerStyleHelper };
